/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { StorageBayList01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const storageBayList01ResetTimestamp = (
  state,
  { currentPage, sorts, filters, pageSize }
) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBayOptions: INITIAL_STATE.toStorageBayOptions,
  toStorageBayOption: INITIAL_STATE.toStorageBayOption
});

export const storageBayList01FetchStorageBayList01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const storageBayList01FetchStorageBayList01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const storageBayList01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const storageBayList01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const storageBayList01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const storageBayList01UploadLoading = (state, { boolean }) => ({
  ...state,
  uploadIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [StorageBayList01Types.STORAGE_BAY_LIST01_RESET_TIMESTAMP]: storageBayList01ResetTimestamp,
  [StorageBayList01Types.STORAGE_BAY_LIST01_FETCH_STORAGE_BAY_LIST01_LOADING]: storageBayList01FetchStorageBayList01Loading,
  [StorageBayList01Types.STORAGE_BAY_LIST01_FETCH_STORAGE_BAY_LIST01_SUCCESS]: storageBayList01FetchStorageBayList01Success,
  [StorageBayList01Types.STORAGE_BAY_LIST01_ADD_SELECTED_DOCUMENTS]: storageBayList01AddSelectedDocuments,
  [StorageBayList01Types.STORAGE_BAY_LIST01_REMOVE_SELECTED_DOCUMENTS]: storageBayList01RemoveSelectedDocuments,
  [StorageBayList01Types.STORAGE_BAY_LIST01_SET_WORKSPACE_VISIBLE]: storageBayList01SetWorkspaceVisible,

  [StorageBayList01Types.STORAGE_BAY_LIST01_UPLOAD_LOADING]: storageBayList01UploadLoading
});
